let recaptchaLoaded = false
let recaptchaLoadPromise = null

export function loadRecaptcha(siteKey) {
  if (recaptchaLoaded) {
    return Promise.resolve()
  }

  if (document.getElementById("recaptcha-script")) {
    recaptchaLoaded = true
    return Promise.resolve()
  }

  if (recaptchaLoadPromise) {
    return recaptchaLoadPromise
  }

  recaptchaLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.id = "recaptcha-script"
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
    script.async = true
    script.defer = true

    script.onload = () => {
      recaptchaLoaded = true
      resolve()
    }
    script.onerror = () => {
      recaptchaLoadPromise = null
      reject(new Error("Failed to load reCAPTCHA"))
    }

    document.body.appendChild(script)
  })

  return recaptchaLoadPromise
}
